<template>
  <div class="filter-horizontal">
    <Collapse :buttonShow="{
      title: 'Mais filtros',
      icon: 'fas fa-arrow-alt-circle-down',
      type: 'info',
    }" :buttonHide="{
      title: 'Menos filtros',
      icon: 'fas fa-arrow-alt-circle-up',
      type: 'warning',
    }">
      <slot name="content-filter-horizontal"></slot>
    </Collapse>
  </div>
</template>

<script>
import Collapse from "./Collapse.vue";
import SelectStatic from "../forms/SelectStatic.vue";
import Select from "../forms/Select.vue";

import { mapMutations, mapState } from "vuex";

export default {
  name: "ListViewWithHandlerData",
  components: { Select, SelectStatic, Collapse },
  props: {
    showTotalPerPage: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      initialValue: {}
    }
  },
  created() {
    this.initialValue = { content: this.paginations.totalPerPage, id: this.paginations.totalPerPage }
  },
  computed: {
    ...mapState("generic", ["paginations"]),
    totalPerPage: {
      get() {
        return this.$store.state.generic.paginations.totalPerPage;
      },
      set(value) {
        this.updateTotalPerPage(value);
      },
    },
  },
  methods: {
    ...mapMutations("generic", [
      "updateTotalPerPage",
    ]),
  }
};
</script>

<style scoped>
.filter-horizontal {
  margin-bottom: 5px;
}
</style>
